const live1 = {
    1 : {'s1': 1, 's2': 0, 's3': 1, 's4': 0, 's5': 1, 's6': 0},
    2 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    3 : {'s1': 2, 's2': 1, 's3': 2, 's4': 1, 's5': 2, 's6': 1},
    4 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    5 : {'s1': 3, 's2': 2, 's3': 3, 's4': 2, 's5': 3, 's6': 2},
    6 : {'s1': 5, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    7 : {'s1': 6, 's2': 5, 's3': 4, 's4': 3, 's5': 4, 's6': 3},
    8 : {'s1': 6, 's2': 6, 's3': 6, 's4': 4, 's5': 4, 's6': 4},
    9 : {'s1': 7, 's2': 8, 's3': 7, 's4': 4, 's5': 5, 's6': 4},
    10: {'s1': 9, 's2': 9, 's3': 7, 's4': 5, 's5': 5, 's6': 5}
}

const live2 = {
    1 : {'s1': 1, 's2': 0, 's3': 1, 's4': 0, 's5': 1, 's6': 0},
    2 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    3 : {'s1': 2, 's2': 1, 's3': 2, 's4': 1, 's5': 2, 's6': 1},
    4 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    5 : {'s1': 3, 's2': 2, 's3': 3, 's4': 2, 's5': 3, 's6': 2},
    6 : {'s1': 5, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    7 : {'s1': 6, 's2': 5, 's3': 4, 's4': 3, 's5': 4, 's6': 3},
    8 : {'s1': 6, 's2': 6, 's3': 6, 's4': 4, 's5': 4, 's6': 4},
    9 : {'s1': 7, 's2': 8, 's3': 7, 's4': 4, 's5': 5, 's6': 4},
    10: {'s1': 9, 's2': 9, 's3': 7, 's4': 5, 's5': 5, 's6': 5}
}

const live3 = {
    1 : {'s1': 1, 's2': 0, 's3': 1, 's4': 0, 's5': 1, 's6': 0},
    2 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    3 : {'s1': 2, 's2': 1, 's3': 2, 's4': 1, 's5': 2, 's6': 1},
    4 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    5 : {'s1': 3, 's2': 2, 's3': 3, 's4': 2, 's5': 3, 's6': 2},
    6 : {'s1': 5, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    7 : {'s1': 6, 's2': 5, 's3': 4, 's4': 3, 's5': 4, 's6': 3},
    8 : {'s1': 6, 's2': 6, 's3': 6, 's4': 4, 's5': 4, 's6': 4},
    9 : {'s1': 7, 's2': 8, 's3': 7, 's4': 4, 's5': 5, 's6': 4},
    10: {'s1': 9, 's2': 9, 's3': 7, 's4': 5, 's5': 5, 's6': 5}
}

const live4 = {
    1 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    2 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    3 : {'s1': 3, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    4 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    5 : {'s1': 5, 's2': 5, 's3': 5, 's4': 5, 's5': 5, 's6': 5},
    6 : {'s1': 8, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    7 : {'s1': 9, 's2': 9, 's3': 7, 's4': 7, 's5': 7, 's6': 7},
    8 : {'s1': 10, 's2': 10, 's3': 10, 's4': 8, 's5': 8, 's6': 8},
    9 : {'s1': 11, 's2': 13, 's3': 11, 's4': 9, 's5': 9, 's6': 9},
    10: {'s1': 14, 's2': 14, 's3': 12, 's4': 10, 's5': 10, 's6': 10}
}

const live5 = {
    1 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    2 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    3 : {'s1': 6, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    4 : {'s1': 8, 's2': 8, 's3': 8, 's4': 8, 's5': 8, 's6': 8},
    5 : {'s1': 10, 's2': 10, 's3': 10, 's4': 10, 's5': 10, 's6': 10},
    6 : {'s1': 14, 's2': 12, 's3': 12, 's4': 12, 's5': 12, 's6': 12},
    7 : {'s1': 16, 's2': 16, 's3': 14, 's4': 14, 's5': 14, 's6': 14},
    8 : {'s1': 18, 's2': 18, 's3': 18, 's4': 16, 's5': 16, 's6': 16},
    9 : {'s1': 20, 's2': 22, 's3': 20, 's4': 20, 's5': 18, 's6': 18},
    10: {'s1': 24, 's2': 24, 's3': 22, 's4': 20, 's5': 20, 's6': 20}
}

const liveMap = {
    1: live1,
    2: live2,
    3: live3,
    4: live4,
    5: live5
}

const season3 = {
    1 : {'s1': 1, 's2': 0, 's3': 1, 's4': 0, 's5': 1, 's6': 0},
    2 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    3 : {'s1': 2, 's2': 1, 's3': 2, 's4': 1, 's5': 2, 's6': 1},
    4 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    5 : {'s1': 3, 's2': 2, 's3': 3, 's4': 2, 's5': 3, 's6': 2},
    6 : {'s1': 5, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    7 : {'s1': 6, 's2': 5, 's3': 4, 's4': 3, 's5': 4, 's6': 3},
    8 : {'s1': 6, 's2': 6, 's3': 6, 's4': 4, 's5': 4, 's6': 4},
    9 : {'s1': 7, 's2': 8, 's3': 7, 's4': 4, 's5': 5, 's6': 4},
    10: {'s1': 9, 's2': 9, 's3': 7, 's4': 5, 's5': 5, 's6': 5}
}

const season4 = {
    1 : {'s1': 1, 's2': 0, 's3': 1, 's4': 0, 's5': 1, 's6': 0},
    2 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    3 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    4 : {'s1': 3, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    5 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    6 : {'s1': 5, 's2': 5, 's3': 5, 's4': 5, 's5': 5, 's6': 5},
    7 : {'s1': 6, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    8 : {'s1': 7, 's2': 7, 's3': 8, 's4': 7, 's5': 7, 's6': 7},
    9 : {'s1': 8, 's2': 9, 's3': 9, 's4': 8, 's5': 8, 's6': 8},
    10: {'s1': 10, 's2': 10, 's3': 10, 's4': 9, 's5': 9, 's6': 9}
}

const season5 = {
    1 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    2 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    3 : {'s1': 4, 's2': 3, 's3': 4, 's4': 3, 's5': 4, 's6': 3},
    4 : {'s1': 5, 's2': 5, 's3': 5, 's4': 5, 's5': 5, 's6': 5},
    5 : {'s1': 7, 's2': 7, 's3': 8, 's4': 7, 's5': 7, 's6': 7},
    6 : {'s1': 9, 's2': 9, 's3': 9, 's4': 9, 's5': 9, 's6': 9},
    7 : {'s1': 11, 's2': 11, 's3': 11, 's4': 11, 's5': 11, 's6': 11},
    8 : {'s1': 13, 's2': 13, 's3': 14, 's4': 13, 's5': 13, 's6': 13},
    9 : {'s1': 15, 's2': 16, 's3': 16, 's4': 15, 's5': 15, 's6': 15},
    10: {'s1': 18, 's2': 18, 's3': 18, 's4': 17, 's5': 17, 's6': 17}
}

const seasonMap = {
    3: season3,
    4: season4,
    5: season5
}

const signature5 = {
    1 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    2 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    3 : {'s1': 6, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    4 : {'s1': 8, 's2': 8, 's3': 8, 's4': 8, 's5': 8, 's6': 8},
    5 : {'s1': 10, 's2': 10, 's3': 10, 's4': 10, 's5': 10, 's6': 10},
    6 : {'s1': 14, 's2': 12, 's3': 12, 's4': 12, 's5': 12, 's6': 12},
    7 : {'s1': 16, 's2': 16, 's3': 14, 's4': 14, 's5': 14, 's6': 14},
    8 : {'s1': 18, 's2': 18, 's3': 18, 's4': 16, 's5': 16, 's6': 16},
    9 : {'s1': 20, 's2': 22, 's3': 20, 's4': 20, 's5': 18, 's6': 18},
    10: {'s1': 24, 's2': 24, 's3': 22, 's4': 20, 's5': 20, 's6': 20}
}

const impact4 = {
    1 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    2 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    3 : {'s1': 3, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    4 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    5 : {'s1': 5, 's2': 5, 's3': 5, 's4': 5, 's5': 5, 's6': 5},
    6 : {'s1': 8, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    7 : {'s1': 9, 's2': 9, 's3': 7, 's4': 7, 's5': 7, 's6': 7},
    8 : {'s1': 10, 's2': 10, 's3': 10, 's4': 8, 's5': 8, 's6': 8},
    9 : {'s1': 11, 's2': 13, 's3': 11, 's4': 9, 's5': 9, 's6': 9},
    10: {'s1': 14, 's2': 14, 's3': 12, 's4': 10, 's5': 10, 's6': 10}
}

const goldenGlove4 = {
    1 : {'s1': 1, 's2': 1, 's3': 1, 's4': 1, 's5': 1, 's6': 1},
    2 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    3 : {'s1': 3, 's2': 3, 's3': 3, 's4': 3, 's5': 3, 's6': 3},
    4 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    5 : {'s1': 5, 's2': 5, 's3': 5, 's4': 5, 's5': 5, 's6': 5},
    6 : {'s1': 8, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    7 : {'s1': 9, 's2': 9, 's3': 7, 's4': 7, 's5': 7, 's6': 7},
    8 : {'s1': 10, 's2': 10, 's3': 10, 's4': 8, 's5': 8, 's6': 8},
    9 : {'s1': 11, 's2': 13, 's3': 11, 's4': 9, 's5': 9, 's6': 9},
    10: {'s1': 15, 's2': 15, 's3': 13, 's4': 11, 's5': 11, 's6': 11}
}

const goldenGlove5 = {
    1 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    2 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    3 : {'s1': 6, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    4 : {'s1': 8, 's2': 8, 's3': 8, 's4': 8, 's5': 8, 's6': 8},
    5 : {'s1': 10, 's2': 10, 's3': 10, 's4': 10, 's5': 10, 's6': 10},
    6 : {'s1': 14, 's2': 12, 's3': 12, 's4': 12, 's5': 12, 's6': 12},
    7 : {'s1': 16, 's2': 16, 's3': 14, 's4': 14, 's5': 14, 's6': 14},
    8 : {'s1': 18, 's2': 18, 's3': 18, 's4': 16, 's5': 16, 's6': 16},
    9 : {'s1': 20, 's2': 22, 's3': 20, 's4': 20, 's5': 18, 's6': 18},
    10: {'s1': 25, 's2': 25, 's3': 23, 's4': 21, 's5': 21, 's6': 21}
}

const goldenGloveMap = {
    4: goldenGlove4,
    5: goldenGlove5
}

const international5 = {
    1 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    2 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    3 : {'s1': 6, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    4 : {'s1': 8, 's2': 8, 's3': 8, 's4': 8, 's5': 8, 's6': 8},
    5 : {'s1': 10, 's2': 10, 's3': 10, 's4': 10, 's5': 10, 's6': 10},
    6 : {'s1': 14, 's2': 12, 's3': 12, 's4': 12, 's5': 12, 's6': 12},
    7 : {'s1': 16, 's2': 16, 's3': 14, 's4': 14, 's5': 14, 's6': 14},
    8 : {'s1': 18, 's2': 18, 's3': 18, 's4': 16, 's5': 16, 's6': 16},
    9 : {'s1': 20, 's2': 22, 's3': 20, 's4': 20, 's5': 18, 's6': 18},
    10: {'s1': 24, 's2': 24, 's3': 22, 's4': 20, 's5': 20, 's6': 20}
}

const allStar5 = {
    1 : {'s1': 2, 's2': 2, 's3': 2, 's4': 2, 's5': 2, 's6': 2},
    2 : {'s1': 4, 's2': 4, 's3': 4, 's4': 4, 's5': 4, 's6': 4},
    3 : {'s1': 6, 's2': 6, 's3': 6, 's4': 6, 's5': 6, 's6': 6},
    4 : {'s1': 8, 's2': 8, 's3': 8, 's4': 8, 's5': 8, 's6': 8},
    5 : {'s1': 10, 's2': 10, 's3': 10, 's4': 10, 's5': 10, 's6': 10},
    6 : {'s1': 14, 's2': 12, 's3': 12, 's4': 12, 's5': 12, 's6': 12},
    7 : {'s1': 16, 's2': 16, 's3': 14, 's4': 14, 's5': 14, 's6': 14},
    8 : {'s1': 18, 's2': 18, 's3': 18, 's4': 16, 's5': 16, 's6': 16},
    9 : {'s1': 20, 's2': 22, 's3': 20, 's4': 20, 's5': 18, 's6': 18},
    10: {'s1': 24, 's2': 24, 's3': 22, 's4': 20, 's5': 20, 's6': 20}
}

const level0 = {'s1': 0, 's2': 0, 's3': 0, 's4': 0, 's5': 0, 's6': 0};


export function calculateEnforcedStates(player) {

    const enforceLevel = player.isAwaken ? 10 : player.level;

    if(enforceLevel === 0) {
        return level0;
    } else if(player.type === '라이브') {
        return liveMap[player.stars][enforceLevel] || liveMap[1][enforceLevel];
    }   else if(player.type === '시즌') {
        return seasonMap[player.stars][enforceLevel] || seasonMap[3][enforceLevel];
    } else if(player.type === '시그니쳐') {
        return signature5[enforceLevel];
    } else if(player.type === '임팩트') {
        return impact4[enforceLevel];
    } else if(player.type === '골든글러브') {
        return goldenGloveMap[player.stars][enforceLevel] || goldenGloveMap[4][enforceLevel];
    } else if(player.type === '국가대표') {
        return international5[enforceLevel];
    } else if(player.type === '올스타') {
        return allStar5[enforceLevel];
    } else {
        return liveMap[1][enforceLevel];
    }
}

export function getMaxLevel(player) {
    const awakenAvailableCardTypes = ['임팩트', '시그니쳐', '골든글러브', '국가대표']

    if(awakenAvailableCardTypes.includes(player.type)) {
        return 10;
    } else {
        return 9;
    }
}

export function isAwakenAvailable(player) {
    const awakenAvailableCardTypes = ['임팩트', '시그니쳐', '골든글러브', '국가대표']
    return awakenAvailableCardTypes.includes(player.type);
}